import React, { useEffect, useMemo, useRef, useState } from 'react'
import Select from 'react-select'
import Events from './_Events'
import Pageview, { pageViewComparationOptions } from './_Pageview'
import Abandon from './_Abandon'
import Interval, { intervalQueryPosfix } from './_Interval'
import { Card } from '../../../../_components'
import { removeErrorDisplay } from '../../_functions'

const Components = {
  "events": Events,
  "pageview": Pageview,
  "abandon": Abandon
}

const triggerOptions = [
  { label: "Abandono", value: "abandon" },
  { label: "Eventos", value: "events" },
  { label: "Visualização de página", value: "pageview" }
]

export function Trigger({data, setData, errors, setErrors, disabled}) {
  const dataTrigger = useMemo( () => {
    const trigger = ( data.momentums ?? [] ).find( ( { type } ) => type === 'trigger' )
    return trigger?.values?.[0]
  }, [ data ] )

  const firstDataTrigger = useRef( dataTrigger )

  const [ selectedFilter, setSelectedFilter ] = useState({})

  useEffect( () => {
    const data = firstDataTrigger.current
    if ( !data ) return console.log( 'no data' )
    const trigger = triggerOptions.find( option => option.value === data.filter )
    if ( !trigger ) return console.log( 'no trigger' )
    const values = data.value ? Array.isArray( data.value ) ? data.value : [ data.value ] : []
    const comparation = pageViewComparationOptions.find( comparation => comparation.value === data.comparation )

    setData( state => {
      const newState = {
        ...state,
        trigger: {
          comparation: comparation.value,
          filter: trigger.value,
          value: values,
          dischargeIn: data.dischargeIn
        },
        raw_trigger_comparation: comparation,
        raw_trigger_type: trigger,
        raw_trigger_value: values.join( ' e ' ),
        raw_dischargeIn: data.dischargeIn?.map( dischargeIn => {
          let reducedDischargeIn = Number( dischargeIn )
  
          const minimunIntervalQuery = Math.min( ...Object.values( intervalQueryPosfix ) )
          const dischargeInObject = {}
  
          while( reducedDischargeIn > minimunIntervalQuery ) {
            // eslint-disable-next-line no-loop-func
            const intervalQueryPostfixKey = Object.keys( intervalQueryPosfix ).find( ( key ) => {
              const value = intervalQueryPosfix[key]
              if ( reducedDischargeIn >= value ) return true
              return false
            } )
  
            const intervalQueryPostfixValue = intervalQueryPosfix[intervalQueryPostfixKey]
            reducedDischargeIn -= intervalQueryPostfixValue
            dischargeInObject[intervalQueryPostfixKey] = ( dischargeInObject[intervalQueryPostfixKey] ?? 0 ) + 1
          }
  
          const query = Object.entries( dischargeInObject ).map( ( [ key, qty ] ) => `${qty}${key}` ).join( ' ' )

          return { label: query, value: query }
        } )
      }

      return newState
    } )
    setSelectedFilter( trigger )
  }, [ setData ] )

  const handleFilterChange = (e, type) => {
    removeErrorDisplay(type, errors, setErrors)

    const raw = `raw_${type}`

    setSelectedFilter(e)
    setData({...data, trigger: {filter: e.value}, [raw]: e})
  }

  const defineComponent = () => {
    if ( !selectedFilter.value ) return

    let Component = Components[selectedFilter.value]
    if ( !Component ) return

    return <Component disabled={disabled} localData={data} setLocalData={setData} errors={errors} setErrors={setErrors}/>
  }

  return (
    <Card
      title="Gatilhos"
      icon="TargetIcon"
      description={"Melhor momento para notificar os clientes. <strong>Exemplo</strong>: Visualizações de determinada página e até mesmo a recorrência."}
      required={true}
      help={"O gatilho define um filtro customizado baseado em ações do usuário. Aqui é definido o filtro de visualização de página, disparo de eventos customizados ou até mesmo abandono de carrinho."}
    >
      <div className="input__group">
        <Select
          options={triggerOptions}
          value={data.raw_trigger_type}
          className={`
            selectable
            ${errors.triggerType && "selectable--error"}
          `}
          isDisabled={disabled}
          placeholder="Selecione o tipo de gatilho"
          onChange={(e) => handleFilterChange(e, 'trigger_type')}
        />

        { defineComponent() }

        {
          selectedFilter.value ?
            <Interval disabled={disabled} localData={data} setLocalData={setData} errors={errors} setErrors={setErrors}/>
          : null
        }
      </div>
    </Card>
  )
}